import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import {
  createLeadProspect,
  deleteLeadAndProspect,
  updateLeadProspect,
} from "../graphQL/graphMutation";
import { useNavigate } from "react-router-dom";
//updateleadandprospect api

export const updateLeadAndProscpectService = async (values, id) => {
  let updateStatus=false
  let errormessage;
  try {
    const res = await request(BASEURL, updateLeadProspect, {
      input: {
        id:id,
        ...values,
      },
    });
    updateStatus=true
  } catch (err) {
    console.error(err.message, "updateLeadAndProscpectService error");
    errormessage=err.response?.errors?.[0]?.message;
    updateStatus=false
  }

  return {updateStatus,errormessage}
};
//deltelead and prospect api
export const delteLeadAndProscpectService = async (id) => {
  let delteStatus=false
  try {
    const res = await request(BASEURL, deleteLeadAndProspect, { id: id });
    delteStatus=true
  } catch (err) {
    console.error(err.message, "delteLeadAndProscpectService error");
   
    delteStatus=false
  }
  return delteStatus
};
//addlead and prospect api
export const addLeadAndProscpectService = async (values) => {

  let status = false;
  let errormessage;
  try {
    const res = await request(BASEURL, createLeadProspect, {
      input: { ...values },
    });

    status = true;
  } catch (err) {
    console.error(err.message, "addLeadAndProscpectService error");
    errormessage=err.response?.errors?.[0]?.message;
    status = false;
  }

  return {status,errormessage};
};
